<!--业主信息账单导出-->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body" style="z-index:0;">
		<template slot="title">
			请选择导出设备
		</template>
		<div style="width: 80%;display: flex;align-items: center;">
			<div>
				<span class="selectDate" @click="$emit('startDate')">{{billStratSelectTime.formatByDate()}}<img :src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
			</div>
			<div>
				<span class="selectDate" @click="$emit('endDate')">{{billEndSelectTime.formatByDate()}}<img :src="resourcesStore.getResourcesByName('/meterReading/icon_date.png')" alt="" /></span>
			</div>
		</div>
		<!--选择的设备列表-->
		<div class="deviceList">
            <table>
            	<tr v-for="item in deviceListState">
            		<td>
            			<img :src="getSelectStateImg(item.state)" @click="item.state=!item.state"/>
            		</td>
            		<td>{{item.deviceName}}</td>
            	</tr>
            </table>
		</div>
	</dialogBody>
</template>
<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import resourcesStore from '../../../cache/resourcesStore.js'
	import ownerManagerStore from '@/page/system/meterReading/ownerManagerStore.js'
	export default {
		components: {
			dialogBody,
		},
		props: {
			deviceList: {},
			billStratSelectTime:{},
			billEndSelectTime:{},
		},
		data() {
			return {
				deviceListState:[]
			}
		},
		created() {},
		mounted() {
			if(isempty(this.deviceList)){
				return
			}
			this.deviceList.forEach(item=>{
				var obj=item
				obj.state=false
				this.deviceListState.push(obj)
			})
			
		},
		destroyed() {},
		computed: {
			resourcesStore() {
				return this.$store.resourcesStore.getters
			},
			getSelectStateImg(){
				return (state)=>{
					if(state){
						 return resourcesStore.getters.getResourcesByName('/checkBox/icon_checked.png')	
					}else{
					 return resourcesStore.getters.getResourcesByName('/checkBox/icon_uncheck.png')	
					}
					
				}
			},
			nowOwnerInformation() {
				return ownerManagerStore.state.nowOwnerInformation
			},
		},
		watch: {
			deviceList(nv,ov){
				this.deviceList.forEach(item=>{
				var obj=item
				obj.state=false
				this.deviceListState.push(obj)
			})
			}
		},
		methods: {
			confirm() {
				//确定调用下载接口
				let deviceList=[]
				let deviceNos=''
				this.deviceListState.forEach(item=>{
					if(item.state){
						deviceList.push(item)
					}
				})
				deviceList.forEach((item,index)=>{
					if(index+1<deviceList.length){
						deviceNos+=item.deviceNo+','
					}else{
						deviceNos+=item.deviceNo
					}
				})
				if(isempty(deviceNos)){
					this.$dialogMethod.showMessage('请先选中设备！')
					return
				}
				this.$api.meterReadingApi.exportOwnerElectricityBill(this.nowOwnerInformation.id,deviceNos,this.billStratSelectTime.getTime(),this.billEndSelectTime.getTime(),respon=>{
					saveAs(DWSystemSetting.downloadUrl+'/'+respon)
					this.close()
				})
				
			},
			cancel() {
				this.close()
			},
			close() {
				this.$refs.body.hide()
			},
			open() {
				this.$refs.body.open()
			},
		}
	}
</script>

<style scoped>
	.message-content {
		top: 30% !important;
	}
	.selectDate {
		display: inline-block;
		margin-right: 20px;
		border: solid 1px #E4E4E4;
		border-radius: 4px;
		line-height: 34px;
		vertical-align: top;
		width: 120px;
		padding: 0 10px;
		font-weight: bold;
		color: #C0C4CC;
	}
	
	.selectDate>img {
		float: right;
		width: 17px;
		height: 19px;
		margin: 7px 0;
	}
	.deviceList{
		min-height: 80%;
		width: 100%;
	}
	.deviceList table{
		width: 100%;
		height: 100%;
	}
	.deviceList table tr td{
		padding-top: .1rem;
	}
	.deviceList table tr td:nth-child(1){
		width: 6%;
	}
	.deviceList img{
		width: .2rem;
	}
</style>